import { Form as AntdForm } from "antd";
import React, { JSX, ReactNode } from "react";
import styled from "styled-components";

export interface OrderFormSectionProps {
  title: ReactNode;
  subtitle?: ReactNode;
  children: ReactNode;
}

export default styled(AntdForm)`
  .ant-form-item-label {
    padding-bottom: 2px !important;
  }

  .ant-form-item-label>.ant-form-item-required::before {
    margin-inline-end: 2px !important;
    position: relative;
    top: -4px;
  }

  .ant-form-item-explain-error {
    margin-left: 6px;
  }
`;

